import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from '@/app/store/hooks';
import { selectIsAuthenticated } from '@/features/auth/store/auth-slice';
import { ROUTES } from '@/app/router/route-constants';

/**
 * Restricts guest-only routes (e.g. login) from authenticated users.
 */
export function GuestGuard() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
